// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chip[data-v-5146afa0] {\n  border-radius: 25px;\n  font-size: 16px;\n  font-weight: 700;\n  margin-left: 5px;\n  margin-right: 5px;\n  padding: 4px 16px;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
